import { getApi, getApiExcel, postApi } from 'apis';

const downloadTimeSheetCsvTemplate = async (staffCode:string) => {
	return await getApiExcel(`/import/time-sheet-download/${staffCode}`);
};

const validateDataFromAPIForTimeSheet = async (
	data: any,
	payPeriodId: string
) => {
	return await postApi(
		`/import/time-sheet?payPeriodId=${payPeriodId}`,
		data,
		true
	);
};

const uploadTimeSheetCsv = async (data: any, payPeriodId: string) => {
	return await postApi(
		`/import/time-sheet-upload-csv?payPeriodId=${payPeriodId}`,
		data,
		true
	);
};
const importTimesheetLogs = async (query: any) => {
	return await getApi('/import/import-time-sheet-logs',query);
};


export const importTimesheetApi = {
	downloadTimeSheetCsvTemplate,
	uploadTimeSheetCsv,
	validateDataFromAPIForTimeSheet,
	importTimesheetLogs,
};
